import React, { useState } from "react";
import Feature from "../../components/Feature/Feature";
import Process from "../Process/Process";
import "./Features.css";

const featuresData = [
  {
    title: "Agenda",
    text: "Understanding the goals of the business and discussing the content of the website including discussing the look, feel, and how the website should approach the user's eye",
  },
  {
    title: "Content",
    text: "The best part of the process, this is where we come up with ideas and content for the website and brainstorm the best strategy to get better user reach.",
  },
  {
    title: "Discussion",
    text: "Thorough discussions about design choices and content placement. This is the part where we ask for all of your ideas and take them into account for the rest of the journey",
  },
  {
    title: "Finale",
    text: "After all decisions are finalised and we have a good looking and performant website, we get to perfecting our creation and polishing it to finality.",
  },
];

const Features = () => {
  const [processClicked, setProcessClicked] = useState(false);
  return (
    <>
      <div className="features section__padding" id="features">
        <div className="features-heading">
          <h1 className="gradient__text">
            You have creative control at every part of the process
          </h1>
          <p>
            We are great listeners. We are all ears for all your suggestions and
            inputs. We usually divide creating the perfect website into four
            phases.
          </p>
          <div className="features-cta">
            <a href="#process">
              <button
                className="button"
                onClick={() => setProcessClicked(true)}
              >
                See more
              </button>
            </a>
          </div>
        </div>
        <div className="features-container">
          {featuresData.map((item, index) => (
            <Feature
              title={item.title}
              text={item.text}
              key={item.title + index}
            />
          ))}
        </div>
      </div>
      {processClicked ? (
        <>
          <Process />
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default Features;
